import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CaseModel } from 'src/app/models/case.model';
import { CaseService } from 'src/app/services/case.service';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-case-list',
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.scss']
})
export class CaseListComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  cases$!: Observable<CaseModel[]>;
  errorObject = null;

  displayedColumns: string[] = ['caseId', 'complainer', 'company', 'date', 'contact'];
  datasource!: MatTableDataSource<CaseModel>;


  constructor(private caseService: CaseService, private router: Router, private titleService: TitleService) {
    this.titleService.setTitle("Finansklagenemnda - Min sak");
  }

  ngOnInit(): void {
    this.cases$ = this.caseService.loadAll()
      .pipe(
        catchError(
          (err: HttpErrorResponse) => {
            this.errorObject = err.error.Message ? err.error.Message : err.message;
            return throwError(err);
          })
      );

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }


  openCase(selectedCase: CaseModel) {
    if (selectedCase.AwaitingElkomInvitation != null) {
      this.router.navigate(['/access/consent/', selectedCase.CaseUid]);
    }
    else {
      this.router.navigate(['/cases/', selectedCase.CaseUid]);
    }
  }
}
